import { styled } from '@mui/material/styles';

export const DrawerContent = styled('div')(() => ({
	padding: 24,
	minHeight: '100%',
	display: 'flex',
	flexDirection: 'column',
	boxSizing: 'border-box',
	position: 'relative',
}));
